import React from "react";
import ContentArea from '../components/content-area/Content';
import ComingSoonPage from "../components/homepage/ComingSoonPage";
import RewardsIconPng from "../assets/icons/rewards.png";

// --- IMPLEMENTATION COMMENTED OUT WILL BE RESTORED WHEN COMPLETELY READY FOR PRODUCTION ---
// import { useState } from "react";
// import { Box, Typography, Tabs, Tab } from "@mui/material";
// import RecognitionPng from "../assets/icons/recognition.png";
// import ToolIcon from "../utils/ToolIcon";
// import PenaltiesTab from "../components/rewards/PenaltiesTab";
//
// function Rewards() {
//   const [tab, setTab] = useState(0);
//   return (
//     <ContentArea title={"Rewards"}>
//     <Box sx={{ p: 1 }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center">
//         <Box display="flex" sx={{gap: 2, mb: 2}}>
//         {<img src={RecognitionPng} alt="" style={{ width: "10%", height: "10%" }}/>}
//         <Typography variant="h5" fontWeight="bold" color="white">
//           {"Rewards"}
//         </Typography>
//         </Box>
//         <ToolIcon name={"preview"} size={30}/>
//       </Box>
//       <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//         <Tabs
//           value={tab}
//           onChange={(e, newValue) => setTab(newValue)}
//           sx={{ mt: 2}}
//           TabIndicatorProps={{ style: { display: "none" } }}
//         >
//           <Tab label="Penalties"
//               sx={{
//               color: "#fff",
//               width: "20%",
//               backgroundColor: tab === 0 ? "#5383b3" : "#85a5c6",
//               borderRadius: '20px 20px 0px 0px',
//               "&.Mui-selected": { backgroundColor: "#5383b3", color: "#fff" },
//               "&:focus": { outline: "none" }}}/>
//         </Tabs>
//             <PenaltiesTab />
//     </Box>
//     </Box>
//     </ContentArea>
//   );
// }

function Rewards() {
  return (
    <ContentArea title="Rewards" icon={RewardsIconPng} container={false}>
      <ComingSoonPage />
    </ContentArea>
  );
}

export default Rewards;
